import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "/login",
    component: () => import("@/views/Login/Login"),
  },
  {
    path: "/creditSuggest",
    name: "/creditSuggest",
    component: () => import("@/views/CreditSuggest/CreditSuggest"),
  },
  {
    path: "/result",
    name: "/result",
    component: () => import("@/views/Result/Result"),
    meta: {
      // 审批结果页无 token 依赖，钉钉免登审批成功后需直接展示
      skipAuth: true,
    },
  },
  {
    path: "/freightLedger/:voucherNo",
    name: "/freightLedger",
    component: () => import("@/views/FreightLedger/FreightLedger"),
  },
  {
    path: "/mobileHome",
    name: "/mobileHome",
    component: () => import("@/views/MobileHome/MobileHome"),
  },
  {
    path: "/electronicLock",
    name: "/electronicLock",
    component: () => import("@/views/ElectronicLock/ElectronicLock"),
  },
  {
    path: "/mobile/financeApproval",
    name: "/mobile/financeApproval",
    component: () => import("@/views/FinanceApproval/FinanceApproval"),
    meta: {
      // 融资审批仅依赖请求头 Dingtalk-Code，不需要 login token
      skipAuth: true,
    },
  },
  {
    path: "/mobile/mcFinanceApproval",
    name: "/mobile/mcFinanceApproval",
    component: () => import("@/views/McFinanceApproval/McFinanceApproval"),
    meta: {
      skipAuth: true,
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const access_token = store.state.access_token;

    // 开发环境直接放行
    if (process.env.NODE_ENV === "development") {
        next();
        // next({ path: "/login", query: { back: to.fullPath } });
        return;
    }

  // 钉钉免登鉴权页面直接放行
  if (to.meta?.skipAuth) {
    next();
    return;
  }

    // 生产环境：如果没有 token 且不是访问登录页，则跳转到登录页
  if (!access_token && to.path !== "/login") {
    next({ path: "/login", query: { back: to.fullPath } });
    return;
  }

  // 其他情况正常放行
  next();
});

export default router;
